<script>
import moment from 'moment';
import { isNil, cloneDeep } from 'lodash';

import WEventlevelCountBox from '@/views/event/event-hist/components/EventlevelCountBox';

import MapAPI from '@/api/topologymap/common';

export default {
  name: 'WTopologymapEventlevelCountBox',
  extends: WEventlevelCountBox,
  props: {
  },
  data() {
    return {
    };
  },
  computed: {
    eventlevelCountList: {
      get() {
        if (!isNil(this.eventlevelList)) {
          return cloneDeep(this.eventlevelList);
        }
        return [];
      },
      set(val) {
        if (val === 'init') {
          for (let i = 0; i < this.eventlevelCountList.length; i += 1) {
            if (!isNil(this.eventlevelCountList[i].eventCount)) {
              this.$delete(this.eventlevelCountList[i], 'eventCount');
            }
          }
        }
        this.$forceUpdate();
      },
    },
  },
  watch: {
    active: {
      handler(value) {
        if (value === false) {
          this.clear();
        }
      },
    },
  },
  methods: {
    loadData() {
      if (isNil(this.active) || !this.active) {
        return;
      }
      const params = {
        startDatetime: moment().subtract(1, 'days').valueOf(),
        endDatetime: moment().valueOf(),
        mapId: this.$store.getters.getCurrentMapId,
      };
      this.setEventHistStatsParams(params);
      this.eventlevelCountList = 'init';
      MapAPI.getEventHistStatsGroupByEventlevel(params).then((response) => {
        const result = response.data;
        const totalCount = result.data.filter((item) => item.eventlevelId === '_TOTAL')[0];
        this.total = totalCount.eventCount;
        if (result.success) {
          this.eventlevelCountList.forEach((item) => {
            const eventCount = result.data.filter((countItem) => countItem.eventlevelId === item.eventlevelId)[0];
            if (!isNil(eventCount)) {
              item.eventCount = eventCount.eventCount;
            } else if (isNil(eventCount) && !isNil(item.eventCount)) {
              this.$delete(item, 'eventCount');
            }
          });
        }
      });
    },
    clear() {
      Object.assign(this.$data, this.$options.data());
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/event/TopologymapEventlevelCountBox.vue